document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(".hot-spots--js:not(.inited)").forEach(section => {
        section.classList.add("inited")
        const switcherElem = section.querySelector("[data-spot-switcher]")
        switcherElem.querySelectorAll("li").forEach(tab => {
            tab.addEventListener("click", ()=>{
                console.log()
                switcherElem.classList.toggle("hot-spots__switcher--active", tab.hasAttribute("data-image-mode"))
            })
        })
    })
})